export default __webpack_public_path__ + "static/media/node.b235615d.png";